// @TODO: Deprecate this constant
const API_ROOT = '';
const LOGIN_MICROSOFT = `${API_ROOT}/api/login/microsoft`;
const LOGIN_GOOGLE = `${API_ROOT}/api/login/google`;
const LOGIN_OKTA = `${API_ROOT}/api/login/okta`;

const NAVIGATION = {
  PRIORITIES: 'priorities',
  APPLICATIONS: 'applications',
  MOVE_INS: 'move-ins',
  RENEWALS: 'renewals',
  COLLECTIONS: 'collections',
  MOVE_OUTS: 'move-outs',
  SERVICE_REQUESTS: 'service-requests',
  MAINTENANCE_REQUESTS: 'maintenance-requests',
  MAKE_READIES: 'make-readies',
  LEASE_AUDITS: 'lease-audits',
  DELINQUENCIES: 'delinquencies',
};

const TABLES = {
  LEASE_AUDITS: 'lease_audits',
  LEASE_AUDIT_HOT_SPOTS: 'lease_audit_hot_spots',
  LEASE_AUDIT_HOT_SPOT_CHECKS: 'lease_audit_hot_spot_checks',
};

export {
  API_ROOT,
  LOGIN_GOOGLE,
  LOGIN_MICROSOFT,
  LOGIN_OKTA,
  NAVIGATION,
  TABLES,
};
